import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import { t, tr } from "../../i18n/translations";

export default function Testimonials() {
  const { lang } = useLang();
  const items = t.testimonials.items;
  return (
    <section id="testimonials" className="bg-[#F4F0EC] py-28 sm:py-36" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <p className="overline text-[#8B6D5E] mb-4">{tr(t.testimonials.overline, lang)}</p>
        <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[1] mb-16">
          {tr(t.testimonials.title, lang)}
        </h2>

        {/* Desktop grid */}
        <div className="hidden md:grid md:grid-cols-3 gap-10 lg:gap-16">
          {items.map((it, i) => (
            <TestimonialCard key={i} it={it} i={i} lang={lang} />
          ))}
        </div>

        {/* Mobile carousel */}
        <div
          className="md:hidden flex gap-5 overflow-x-auto snap-x snap-mandatory scroll-smooth -mx-6 px-6 pb-6 no-scrollbar"
          data-testid="testimonials-carousel-mobile"
        >
          {items.map((it, i) => (
            <div
              key={i}
              className="snap-center flex-none w-[85%]"
              data-testid={`testimonial-slide-${i}`}
            >
              <TestimonialCard it={it} i={i} lang={lang} />
            </div>
          ))}
        </div>

        {/* Mobile dots */}
        <div className="md:hidden flex items-center justify-center gap-2 mt-2" aria-hidden>
          {items.map((_, i) => (
            <span key={i} className="w-1.5 h-1.5 rounded-full bg-[#1A1A1A]/25" />
          ))}
        </div>
      </div>

      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </section>
  );
}

function TestimonialCard({ it, i, lang }) {
  return (
    <figure className="border-t border-[#1A1A1A] pt-8 h-full" data-testid={`testimonial-${i}`}>
      <span className="font-serif italic text-7xl text-[#8B6D5E] leading-none block mb-4">&ldquo;</span>
      <blockquote className="font-serif text-2xl leading-snug tracking-tight text-[#1A1A1A] mb-8">
        {tr(it.quote, lang)}
      </blockquote>
      <figcaption className="overline text-[#5C5C5C]">{it.author}</figcaption>
    </figure>
  );
}
